const TRIGGER_SELECTOR = '.js-header-search-opener';
const SEARCH_FORM_SELECTOR = '#header-search-form';
const ACTIVE_CLASS = 'active';
const BODY_ATTR = 'data-header-search-open';

const searchOpenerElements = document.querySelectorAll<HTMLButtonElement>(TRIGGER_SELECTOR);
const searchFormElement = document.querySelector<HTMLElement>(SEARCH_FORM_SELECTOR);

let activeOpener: HTMLButtonElement | null = null;

function focusSearchInput() {
  const input = searchFormElement?.querySelector<HTMLInputElement>('input[type="search"]');
  if (!input)
    return;

  input.focus();

  if (document.activeElement !== input && searchFormElement) {
    searchFormElement.addEventListener('transitionend', () => input.focus(), { once: true });
  }
}

function removeListeners() {
  document.removeEventListener('click', handleOutsideClick, true);
  document.removeEventListener('keydown', handleEscapeKey);
}

function closeSearch() {
  if (!searchFormElement || !activeOpener)
    return;

  activeOpener.setAttribute('aria-expanded', 'false');
  searchFormElement.classList.remove(ACTIVE_CLASS);
  document.body.removeAttribute(BODY_ATTR);
  removeListeners();
  activeOpener = null;
}

function openSearch(buttonElement: HTMLButtonElement) {
  if (!searchFormElement)
    return;

  activeOpener = buttonElement;
  buttonElement.setAttribute('aria-expanded', 'true');
  searchFormElement.classList.add(ACTIVE_CLASS);
  document.body.setAttribute(BODY_ATTR, '');
  focusSearchInput();
  document.addEventListener('click', handleOutsideClick, true);
  document.addEventListener('keydown', handleEscapeKey);
}

function handleOutsideClick(event: Event) {
  const target = event.target as HTMLElement;
  const isInsideSearch = !!target.closest(SEARCH_FORM_SELECTOR);
  const isOpenerClick = !!target.closest(TRIGGER_SELECTOR);

  if (!isInsideSearch && !isOpenerClick) {
    event.preventDefault();
    event.stopPropagation();
    closeSearch();
  }
}

function handleEscapeKey(event: KeyboardEvent) {
  if (event.key === 'Escape') {
    closeSearch();
  }
}

function toggle(buttonElement: HTMLButtonElement) {
  if (buttonElement.getAttribute('aria-expanded') === 'true') {
    closeSearch();
  }
  else {
    openSearch(buttonElement);
  }
}

export function initHeaderSearch(): void {
  if (!searchFormElement)
    return;

  for (const buttonElement of searchOpenerElements) {
    buttonElement.addEventListener('click', () => {
      toggle(buttonElement);
    });
  }
}
